// Tracks engagement events via sendBeacon (primary) with fetch+keepalive fallback.
// sendBeacon is CSRF-exempt — the engagement events endpoint uses skip_forgery_protection.
// Note: useEffect fires twice in React 18 StrictMode (dev only). Production counts are correct.
export function trackEvent(shareToken: string, eventType: string, extra?: object): void {
  const payload = JSON.stringify({ event_type: eventType, ...extra })
  const url = `/g/${shareToken}/engagement_events`

  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }))
    return
  }

  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content
  fetch(url, {
    method: 'POST',
    keepalive: true,
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken ?? '' },
    body: payload,
  }).catch(() => {})
}
